import React, {useState} from "react";
import Label from "./Label";
import Input from "./Input";
import UploadImage from "./UploadImage";
import {useUIModelApi} from "../../contexts/UIModelApiContext";
import {UIModelAPI} from "../../types/api.types";
import {toast} from "react-toastify";
import DownloadIndicator from "../../../../../../Components/GMS/Rules/Components/DownloadIndicator";

type CreateUIModelProps = {
    id?: string;
    projectId: string
    uiModel?: UIModelAPI | null
    onClose: () => void;
    onSuccess: (id:string) => void;
    isCopyModel?: boolean;
}

const CreateUIModel = ({id, projectId, uiModel, onClose, onSuccess, isCopyModel}: CreateUIModelProps) => {
    const baseId = id || 'create-ui-model';

    const [file, setFile] = useState<File | null>(null);
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState(`${isCopyModel ? 'Copy of ' : ''}${uiModel?.name ?? ''}`);
    const [error, setError] = useState<string | null>(null);
    const [imageRemoved, setImageRemoved] = useState<boolean>(false);
    const {createUIModel, updateUIModel} = useUIModelApi();

    return (
        <div id={baseId} data-testid={baseId} className='tw-w-[402px] tw-py-[12px] tw-px-[20px] tw-space-y-[16px]'>
            <div id={`${baseId}-name-section`} className='tw-space-y-[6px]'>
                <Label id={`${baseId}-name-label`} text={'UI Model Name'}/>
                <Input id={`${baseId}-name-input`} placeholder="Enter Name" value={name} error={error} onChangeValue={(e) => setName(e)} disabled = {false}/>
            </div>
            <div id={`${baseId}-image-section`} className="tw-space-y-[10px]">
                <Label id={`${baseId}-image-label`} text="Add Launch Image"/>
                <UploadImage id={`${baseId}-image-upload`} setFileParent={setFile} launchIcon={!imageRemoved ? uiModel?.launchIcon : undefined} onRemovePressed={() => {
                    if(uiModel != null && !imageRemoved) {
                        setImageRemoved(true);
                    }
                }} />
            </div>
            <div id={`${baseId}-actions`} className='tw-flex tw-gap-2 tw-justify-end tw-py-[14px]'>
                <button id={`${baseId}-cancel-btn`} data-testid={`${baseId}-cancel-btn`} className='popup-button-outline' onClick={onClose}>Cancel</button>
                <button id={`${baseId}-save-btn`} data-testid={`${baseId}-save-btn`} disabled={name.length === 0} onClick={async () => {
                    if(loading) return;
                    setError(null);
                    if(name.length <= 0) {
                        setError('Enter name')
                        return;
                    }
                    setLoading(true);
                    const imageFile = file == null ? !imageRemoved ? uiModel?.launchIcon ?? '' : '' : file;
                    try {
                        if (uiModel == null) {
                            await createUIModel(name, file);
                        } else {
                            if(isCopyModel === true) {
                                await createUIModel(name, imageFile, uiModel?.id, true);
                            } else {
                                await updateUIModel(uiModel?.id ?? '', name, imageFile);
                            }
                        }
                    setLoading(false);
                    onSuccess('');
                    } catch (e: any) {
                        toast.error(e.message ?? 'Error');
                        setLoading(false);
                        console.log(e)
                    }
                }}
                 className='popup-button-filled'>
                    {loading ? <DownloadIndicator id="create-ui-model-loader" message={''} color="#FFFFFF"/>  : uiModel == null ? 'Create' : isCopyModel ? 'Save Copy' : 'Update'}
                </button>
            </div>
        </div>
    );
}

export default CreateUIModel;